<template lang="pug">
#modal-send-or-edit-monitoramento
    el-dialog(
        :visible.sync='showMonitoramentoModal',
        @close='changeShowMonitoramentoModal',
        width='600px'
    )
        span(slot='title')
            h1.mb-2.font-weight-bold {{ actionType === 'send' || actionType === 'addCiclo' ? $t('mensagens.territorio.enviarPara') : $t('mensagens.comuns.editar') }} {{ $t('mensagens.comuns.monitoramento.tituloMinusculo') }}
            h2 {{ selectedTerritorioNome }}
            div(v-if='dadosMonitoramentoAtivos.length')
                h5.mb-2.fontTitle
                    | {{ $t('mensagens.territorio.territorioJaPossuiMonitoramentoAtivo') }}
                el-table(:data='dadosMonitoramentoAtivos')
                    el-table-column(:label="$t('mensagens.territorio.labels.tipo')", min-width='180')
                        template(slot-scope='scope')
                            span
                                | {{ scope.row.tipoMonitoramento.nome }}
                    el-table-column(:label="$t('mensagens.territorio.labels.dataEnvio')", min-width='180')
                        template(slot-scope='scope')
                            span
                                | {{ dataFormatada(scope.row.dataCadastro) }}
                    el-table-column(:label="$t('mensagens.territorio.cicloAno')", min-width='180')
                        template(slot-scope='scope')
                            span
                                | {{ scope.row.tipoMonitoramento.nome !== 'Socioambiental' ? scope.row.safra.descricao : '-' }}
        .column
            el-form.formContainer.w-100.mb-3.p-0(
                :model='territorioParaMonitoramento',
                :rules='rules',
                ref='formularioDadosMonitoramento'
            )
                el-form-item.is-required.my-3(
                    :label="$t('mensagens.territorio.selecioneTIpoMonitoramento')",
                    prop='tiposMonitoramento'
                )
                    el-radio-group.radioPosition(
                        v-if='actionType !== "send" || quantidadeSocioambiental !== null',
                        value='AGRICOLA'
                    )
                        el-radio#AC(disabled, label='AGRICOLA')
                            | {{ $t('mensagens.territorio.agricola') }}
                    el-radio-group.radioPosition(
                        v-else,
                        v-model='tiposMonitoramentoEscolhidos'
                    )
                        el-radio#AC(
                            label='AGRICOLA',
                            @click.native='tipoMonitorado("AGRICOLA")'
                        )
                            | {{ $t('mensagens.territorio.agricola') }}
                        el-radio#SA(
                            label='SOCIOAMBIENTAL',
                            @click.native='tipoMonitorado("SOCIOAMBIENTAL")'
                        )
                            | {{ $t('mensagens.territorio.socioambiental') }}
                el-form-item.my-3(:label="$t('mensagens.territorio.culturaEsperada')")
                    el-select.w-100(
                        v-model='territorioParaMonitoramento.cultura',
                        :placeholder="$t('mensagens.territorio.selecione')",
                        clearable,
                        :disabled='!agricolaEscolhido'
                    )
                        el-option(
                            v-for='cultura in culturasEsperadas',
                            :key='"cultura" + cultura.id',
                            :value='cultura.id',
                            :label='cultura.nome'
                        ) {{ cultura.nome }}
                el-form-item.my-3(
                    :label="$t('mensagens.territorio.dataPlantioEsperada')"
                )
                    el-date-picker.w-100(
                        v-model='territorioParaMonitoramento.dataPlantio',
                        type='date',
                        format='dd/MM/yyyy',
                        value-format='yyyy-MM-dd',
                        placeholder='',
                        :disabled='!agricolaEscolhido',
                        clearable
                    )
                el-form-item.my-3(:label="$t('mensagens.territorio.areaPlantioEsperada')")
                    el-input-number(
                        :disabled='!agricolaEscolhido',
                        v-model='territorioParaMonitoramento.areaDoPlantio',
                        :precision='2',
                        :step='0.01',
                        :min='0.0'
                    )
                el-form-item.my-3(
                    :label="$t('mensagens.territorio.cicloAno')",
                    :class='tiposMonitoramentoEscolhidos.includes("AGRICOLA") ? "is-required" : ""'
                )
                    el-select.w-100(
                        v-model='territorioParaMonitoramento.idSafra',
                        :placeholder="$t('mensagens.territorio.selecione')",
                        value-key='descricao',
                        :disabled='!agricolaEscolhido'
                    )
                        el-option(
                            v-for='cicloAno in objetoCicloAno',
                            :key='"cicloAno" + cicloAno.descricao',
                            :value='cicloAno.id',
                            :label='cicloAno.descricao'
                        ) {{ cicloAno.descricao }}

                el-form-item.my-3(:label="$t('mensagens.territorio.produtividadeEsperada') + formatarUnidadeDeProdutividade()")
                    el-input-number(
                        :disabled='!agricolaEscolhido',
                        v-model='territorioParaMonitoramento.produtividade',
                        :precision='2',
                        :step='0.01',
                        :min='0.0'
                    )
                .buttons.buttonsContainer.d-flex.justify-content-between.mx-0
                    BaseButton(
                        type='default',
                        @click='handleCloseModalSendToMonitoramento'
                    ) {{ $t('mensagens.comuns.cancelar') }}

                    BaseButton(
                        type='primary',
                        v-if='actionType !== "edit"',
                        @click.prevent='sendToMonitoramento'
                    ) {{ $t('mensagens.comuns.confirmar') }}
                    BaseButton(
                        type='primary',
                        v-else,
                        @click.prevent='editarAreaMonitoramento'
                    ) {{ $t('mensagens.comuns.salvar') }}
</template>

<script>
import MonitoramentoService from '@/services/MonitoramentoService';
import { mapActions, mapGetters } from 'vuex';
import UtilsService from '@/services/UtilsService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import TerritorioService from '@/services/TerritorioService';

export default {
    name: 'SendOrEditMonitoramento',
    components: {
        BaseButton
    },
    emits: ['atualizado'],
    props: {
        selectedTerritorioNome: {
            type: String,
            required: true
        },
        selectedTerritorio: {
            type: Object,
            required: true
        },
        actionType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            rules: {
                tiposMonitoramento: [
                    { validator: this.checkTipo, trigger: 'blur' }
                ]
            },
            territorioParaMonitoramento: {
                idTerritorio: null,
                cultura: null,
                dataPlantio: null,
                areaDoPlantio: null,
                idSafra: null,
                produtividade: null,
                tiposMonitoramento: []
            },
            quantidadeSocioambiental: null,
            tipo: null,
            tiposMonitoramentoEscolhidos: [],
            dadosMonitoramentoAtivos: [],
            culturasEsperadas: [
                { nome: 'Soja', id: 1, value: 1 },
                { nome: 'Milho', id: 2, value: 2 },
                { nome: 'Algodão', id: 3, value: 3 },
                { nome: 'Outros', id: 4, value: 4 }
            ],
            objetoCicloAno: null
        };
    },
    watch: {
        tiposMonitoramentoEscolhidos: {
            handler(val) {
                this.territorioParaMonitoramento.tiposMonitoramento = val;
            },
            immediate: true
        }
    },
    created() {
        this.clearAll();
        this.fetchSafras();
        this.buscaAreaMonitorada();
        this.tiposMonitoramentoEscolhidos =
            this.actionType !== 'send' ? ['AGRICOLA'] : [];
        this.tipo = this.actionType !== 'send' ? 'AGRICOLA' : '';
    },
    computed: {
        ...mapGetters(['showMonitoramentoModal']),
        agricolaEscolhido() {
            return this.tiposMonitoramentoEscolhidos.includes('AGRICOLA');
        }
    },
    methods: {
        checkTipo(rule, value, callback) {
            if (this.tipo === '' || this.tipo === null) {
                return callback(
                    new Error(this.$t('mensagens.territorio.escolhaUmTipoMonitoramento'))
                );
            }
            callback();
        },
        ...mapActions(['changeShowMonitoramentoModal']),
        handleCloseModalSendToMonitoramento() {
            this.changeShowMonitoramentoModal();
        },
        tipoMonitorado(value) {
            this.tipo = value;
        },
        dataFormatada(data) {
            var mes = data.substring(0, 2);
            var dia = data.substring(3, 5);
            var ano = data.substring(6, 10);
            return dia + '/' + mes + '/' + ano;
        },
        validaSocioambiental(value) {
            Object.keys(value).forEach(item => {
                if (value[item].tipoMonitoramento.nome === 'Socioambiental') {
                    this.quantidadeSocioambiental += 1;
                }
            });
        },

        buscaAreaMonitorada() {
            MonitoramentoService.buscaAreaMonitorada(
                this.selectedTerritorio.idTerritorio
            )
                .then(response => {
                    this.dadosMonitoramentoAtivos = response.data;
                    this.validaSocioambiental(this.dadosMonitoramentoAtivos);
                    if (this.actionType === 'send') {
                        this.tiposMonitoramentoEscolhidos =
                            this.quantidadeSocioambiental !== null
                                ? ['AGRICOLA']
                                : [];
                        this.tipo =
                            this.quantidadeSocioambiental !== null
                                ? 'AGRICOLA'
                                : '';
                    } else {
                        this.tiposMonitoramentoEscolhidos =
                            this.actionType !== 'send' ? ['AGRICOLA'] : [];
                        this.tipo =
                            this.actionType !== 'send' ? 'AGRICOLA' : '';
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.erroAoEnviarTerritorioMonitoramento')
                    });
                });
        },

        async verificaCicloAno(value, monitorado) {
            let filtrado = '';
            const response = await MonitoramentoService.verificarTerritorio(
                value.idTerritorio
            );
            const data = await response.data;
            if (data.length > 0) {
                filtrado = data.filter(
                    item =>
                        item.safra !== null &&
                        item.safra.id === monitorado.idSafra
                );
            }

            return filtrado.length > 0;
        },

        sendToMonitoramento() {
            this.$refs.formularioDadosMonitoramento.validate(async valid => {
                if (valid) {
                    if (
                        this.tiposMonitoramentoEscolhidos.includes(
                            'AGRICOLA'
                        ) &&
                        !this.territorioParaMonitoramento.idSafra
                    ) {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.monitoramentoEscolhidoCicloPreenchido')
                        });
                        return;
                    }

                    if (
                        !this.territorioParaMonitoramento.tiposMonitoramento.includes(
                            'AGRICOLA'
                        )
                    ) {
                        this.territorioParaMonitoramento.idSafra = null;
                    }

                    const dadosMonitoramento = {
                        ...this.territorioParaMonitoramento,
                        idTerritorio: this.selectedTerritorio.idTerritorio,
                        tipoMonitoramento:
                            this.territorioParaMonitoramento.tiposMonitoramento
                                .length > 1
                                ? this.tipo
                                : this.territorioParaMonitoramento
                                      .tiposMonitoramento[0]
                    };

                    const resultExists = await this.verificaCicloAno(
                        this.selectedTerritorio,
                        dadosMonitoramento
                    );

                    if (resultExists) {
                        this.$notify.warning({
                            message: this.$t('mensagens.territorio.territorioJaMonitoradoCicloAno')
                        });
                    } else {
                        await this.confirma(this.selectedTerritorio.idTerritorio, dadosMonitoramento);
                    }
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.preenchaCamposObrigatorios')
                    });
                    return false;
                }
            });
        },
        fetchSafras() {
            UtilsService.getSafras().then(response => {
                if (response.status === 200) {
                    this.objetoCicloAno = response.data;
                    this.checkIfIsEdit();
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.erroAoBuscarSafras')
                    });
                }
            });
        },
        clearAll() {
            this.clearSendToMonitoramento();
        },
        clearSendToMonitoramento() {
            this.territorioParaMonitoramento = {};
        },
        checkIfIsEdit() {
            if (this.actionType === 'edit') {
                this.territorioParaMonitoramento = {
                    ...this.selectedTerritorio
                };
                if (this.territorioParaMonitoramento.dataPlantio) {
                    this.territorioParaMonitoramento.dataPlantio = new Date(
                        this.territorioParaMonitoramento.dataPlantio
                    ).toISOString();
                }
                this.culturasEsperadas.forEach(item => {
                    if (
                        item.nome ===
                        this.territorioParaMonitoramento.cultura.nome
                    ) {
                        this.territorioParaMonitoramento.cultura = item.id;
                    }
                });
                if (
                    this.territorioParaMonitoramento.cultura.codigo ===
                    'NAO_IDENTIFICADA'
                ) {
                    this.territorioParaMonitoramento.cultura = null;
                }

                this.objetoCicloAno.forEach(item => {
                    if (
                        item.descricao ===
                        this.territorioParaMonitoramento.idSafra
                    ) {
                        this.territorioParaMonitoramento.idSafra = item.id;
                    }
                });
                if (
                    this.selectedTerritorio.tipoMonitoramento.codigo ===
                    'AGRICOLA_E_SOCIOAMBIENTAL'
                ) {
                    this.tiposMonitoramentoEscolhidos = [
                        'AGRICOLA',
                        'SOCIOAMBIENTAL'
                    ];
                } else {
                    this.tiposMonitoramentoEscolhidos = [
                        this.selectedTerritorio.tipoMonitoramento.codigo
                    ];
                }
            }
        },
        editMonitoramentoRequest(dadosMonitoramento) {
            dadosMonitoramento.tipoMonitoramento = 'AGRICOLA';
            MonitoramentoService.editarAreaMonitoramento(dadosMonitoramento)
                .then(response => {
                    if (response.status === 200) {
                        this.$notify.success({
                            message: this.$t('mensagens.territorio.enviadoMonitoramentoComSucesso')
                        });
                        this.$emit('atualizado');
                        this.changeShowMonitoramentoModal();
                    } else {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.erroAoEnviarTerritorioMonitoramento')
                        });
                        this.changeShowMonitoramentoModal();
                    }
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.erroAoEnviarTerritorioMonitoramento')
                    });
                    this.changeShowMonitoramentoModal();
                });
        },
        editarAreaMonitoramento() {
            this.$refs.formularioDadosMonitoramento.validate(async valid => {
                if (valid) {
                    if (
                        this.tiposMonitoramentoEscolhidos.includes(
                            'AGRICOLA'
                        ) &&
                        !this.territorioParaMonitoramento.idSafra
                    ) {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.monitoramentoEscolhidoCicloPreenchido')
                        });
                        return;
                    }
                    const dadosMonitoramento = {
                        ...this.territorioParaMonitoramento,
                        idTerritorio: this.selectedTerritorio.idTerritorio,
                        id: this.selectedTerritorio.id,
                        tipoMonitoramento:
                            this.territorioParaMonitoramento.tiposMonitoramento
                                .length > 1
                                ? 'AGRICOLA_E_SOCIOAMBIENTAL'
                                : this.territorioParaMonitoramento
                                      .tiposMonitoramento[0]
                    };

                    if (dadosMonitoramento.cultura != null) {
                        if (
                            dadosMonitoramento.cultura === '' ||
                            typeof dadosMonitoramento.cultura === 'undefined'
                        ) {
                            dadosMonitoramento.cultura = null;
                        }
                    }
                    delete dadosMonitoramento.tiposMonitoramento;
                    delete dadosMonitoramento.nome;
                    const resultExists = await this.verificaCicloAno(
                        this.selectedTerritorio,
                        dadosMonitoramento
                    );

                    if (
                        resultExists &&
                        this.selectedTerritorio.idSafra !==
                            dadosMonitoramento.idSafra
                    ) {
                        this.$notify.warning({
                            message: this.$t('mensagens.territorio.territorioJaMonitoradoCicloAno')
                        });
                    } else {
                        this.editMonitoramentoRequest(dadosMonitoramento);
                    }
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.preenchaCamposObrigatorios')
                    });
                    return false;
                }
            });
        },
        formatarUnidadeDeProdutividade() {
            let algodao;
            this.culturasEsperadas.filter(cultura => {
                if (cultura.nome === 'Algodão') {
                    algodao = cultura.id;
                }
            });
            return this.territorioParaMonitoramento.cultura === algodao ? ' (@/ha)' : ' (sc/ha)';
        },
        async confirma(territorioId, dadosMonitoramento) {
            let territoriosSemCPF = await this.verificaTerritorioPessoaSemCPF(territorioId);
            if (territoriosSemCPF !== '' && dadosMonitoramento.tipoMonitoramento === 'SOCIOAMBIENTAL') {
                await this.$messageBox.confirm(`${this.$t('mensagens.monitoramentoSocioambiental.mensagemPessoaEstrangeira1')}<br/>${this.$t('mensagens.monitoramentoSocioambiental.mensagemPessoaEstrangeira2')}<br/>${this.$t('mensagens.monitoramentoSocioambiental.mensagemPessoaEstrangeira3')}<br/>${territoriosSemCPF}`, this.$t('mensagens.comuns.atencao'), {
                    confirmButtonText: this.$t('mensagens.comuns.confirmar'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning',
                    dangerouslyUseHTMLString: true,
                    customClass: 'tamanho-mensagem',
                    cancelButtonClass: 'cancelar-left',
                    closeOnClickModal: false,
                    confirmButtonClass: 'confirma-focus-out'
                }).then(() => {
                    this.enviarParaMonitoramento(dadosMonitoramento);
                }).catch(() => {
                });
            } else {
                this.enviarParaMonitoramento(dadosMonitoramento);
            }
        },
        async verificaTerritorioPessoaSemCPF(territorioId) {
            const response = await TerritorioService.findById(territorioId);
            const territorio = await response.data;

            let pessoasEstrangeiras = 0;
            let territorios = this.$t('mensagens.operacao.tabela.territorios') + ':<br/>';

            pessoasEstrangeiras = territorio.representantes.filter(representante => representante.cpfCnpj.length < 11);
            territorios += ` - ${territorio.nome}<br/>`;
            return pessoasEstrangeiras > 0 ? territorios : '';
        },
        enviarParaMonitoramento(dadosMonitoramento) {
            MonitoramentoService.envioAreaMonitoramento(
                dadosMonitoramento
            )
                .then(response => {
                    if (response.status === 200) {
                        this.$notify.success({
                            message: this.$t('mensagens.territorio.enviadoMonitoramentoComSucesso')
                        });
                        this.$emit('atualizado');
                        this.changeShowMonitoramentoModal();
                    } else {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.erroAoEnviarTerritorioMonitoramento')
                        });
                        this.changeShowMonitoramentoModal();
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.erroAoEnviarTerritorioMonitoramento')
                    });
                    this.changeShowMonitoramentoModal();
                });
        }

    }
};
</script>

<style lang="scss">
#modal-send-or-edit-monitoramento {
    button {
        cursor: pointer;
    }

    .buttonsContainer > button {
        width: 100px;
    }

    .fontTitle {
        font-size: 14px;
        padding-top: 5px;
    }

    .radioPosition {
        padding-top: 0px;
    }
    .radioPosition .el-radio#SA {
        padding-left: 20px;
    }

    .radioPosition .el-radio#AC {
        padding-left: 20px;
    }

    .el-input-number {
        left: 20px;
    }

    .el-form-item .el-form-item__label {
        font-weight: normal;
    }
}

.cancelar-left {
    float: left;
}

.confirma-focus-out:focus {
    border-color: var(--primary) !important;
    background-color: var(--primary) !important;
    color: var(--white) !important;
}
</style>
